import type {State} from 'src/reducers';
import type {
  TalentPoolListSuggestion,
  TalentPoolList,
  TalentPoolUsersResponse,
  TalentPoolFolder,
  TalentPoolCandidate,
  TalentPoolHierarchy,
  TalentPoolWorkflowFolders,
  TalentPoolStatusGroup,
} from 'src/types/talent-pools';


export const selectTalentPoolListSuggestion = (
  state: State,
): TalentPoolListSuggestion | null | undefined =>
  state.talentPools?.talentPoolListSuggestion;

export const selectTalentPoolList = (
  state: State,
): TalentPoolList | null | undefined => state.talentPools?.talentPoolList;

export const selectTalentPoolUsers = (
  state: State,
): TalentPoolUsersResponse | null | undefined =>
  state.talentPools?.talentPoolUsers;

export const selectTalentPoolDetails = (
  state: State,
): TalentPoolFolder | null | undefined => state.talentPools?.talentPoolDetails;

export const selectTalentPoolSuggestion = (
  state: State,
  suggestionId: number,
): TalentPoolFolder | null | undefined =>
  // @ts-expect-error - TS2339 - Property 'talent_pool_folders' does not exist on type 'TalentPoolListSuggestion'.
  state.talentPools?.talentPoolListSuggestion?.talent_pool_folders?.find(
    // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (suggestion: TalentPoolFolder) =>
      // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
      suggestion.id === parseInt(suggestionId, 10),
  ) ?? null;

export const selectTalentPoolFolders = (
  state: State,
): TalentPoolList | null | undefined => state.talentPools?.talentPoolFolders;

export const selectTalentPoolCandidate = (
  state: State,
): TalentPoolCandidate | null | undefined =>
  state.talentPools?.talentPoolCandidate;

export const selectTRMApplicants = (
  state: State,
): TalentPoolCandidate | null | undefined => state.talentPools?.trmApplicants;

export const selectTalentPoolFolderDetails = (
  state: State,
): TalentPoolFolder | null | undefined =>
  state.talentPools?.talentPoolFolderDetails;

export const selectTalentPoolFoldersHierarchy = (
  state: State,
): TalentPoolHierarchy | null | undefined =>
  state.talentPools?.talentPoolFoldersHierarchy;

export const selectTalentPoolFoldersWorkflow = (
  state: State,
): TalentPoolWorkflowFolders | null | undefined =>
  state.talentPools?.talentPoolFoldersWorkflow;

// talent pool status groups
export const selectTalentPoolStatusGroups = (
  state: State,
): Array<TalentPoolStatusGroup> | null | undefined =>
  state.talentPools?.talentPoolStatusGroups;
